<div class="heading" >
    Technician details
</div>

<form [formGroup]="form" (ngSubmit)="serviceProviderId ? update() : onSubmit()">
    <div class="total-technicians">
        Total technicians: {{ totalTechnicians }}
    </div>

    <formly-form [form]="form" [model]="model" [fields]="fields"></formly-form>

    <button pButton type="submit" class="btn btn-primary">
        {{ serviceProviderId ? 'Update' : 'Finish' }} <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
    </button>
</form>
<!-- Loading overlay -->
<div *ngIf="isLoading" class="overlay">
    <div class="spinner">
        <div class="spinner-bar"></div>
    </div>
</div>